module.exports = __webpack_public_path__ + "img/3.e150fb78.svg";